import { cn } from '@/lib/utils';
import { List, Kanban, Columns } from 'lucide-react';
import type { LoanCenterDirection } from '../use-loan-center-direction';

interface DirectionTabsProps {
  direction: LoanCenterDirection | null;
  onChange: (next: LoanCenterDirection) => void;
  disabled?: boolean;
  className?: string;
}

const TABS: Array<{ id: LoanCenterDirection; label: string; icon: typeof List }> = [
  { id: 'table', label: 'Table', icon: List },
  { id: 'pipeline', label: 'Pipeline', icon: Kanban },
  { id: 'hybrid', label: 'Hybrid', icon: Columns }
];

export function DirectionTabs({ direction, onChange, disabled, className }: DirectionTabsProps) {
  return (
    <div
      className={cn(
        'inline-flex items-center rounded-md bg-muted p-0.5 gap-0.5',
        disabled && 'opacity-60 pointer-events-none',
        className
      )}
      role="tablist"
      aria-label="Loan Center view"
    >
      {TABS.map(tab => {
        const active = direction === tab.id;
        const Icon = tab.icon;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onChange(tab.id)}
            className={cn(
              'inline-flex items-center gap-1.5 rounded px-2.5 py-1 text-[12px] font-medium transition',
              active
                ? 'bg-background text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            )}
          >
            <Icon className="h-3.5 w-3.5" aria-hidden />
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
